import { UserDto } from "@dtos/user.dto";
import { User } from "@models/user.model";
import { BaseConverter } from "@converters/base.converter";
import { PersonConverter } from "@converters/person.converter";


export class UserConverter extends BaseConverter <User,UserDto>{

    private personConverter = new PersonConverter();

    modelToDto(model: User): UserDto {
        return new UserDto(
            model.username,
            model.password,
            model.person? this.personConverter.modelToDto(model.person) : undefined,
            model.role
        )
    }
    dtoToModel(dto: UserDto): User {
        return new User(
            dto.username,
            dto.password,
            dto.person? this.personConverter.dtoToModel(dto.person) : undefined,
            dto.role
        )
    }

}